export const CART_CONTENT = {
  empty: {
    title: 'Your cart is empty',
    description:
      "Looks like you haven't added any cuddly friends yet. Let's find you the perfect companion!",
    buttonLabel: 'Start Shopping',
    buttonPath: '/shop',
  },
  title: 'Shopping Cart',
  itemCount: {
    prefix: 'You have',
    singular: 'item',
    plural: 'items',
    inYourCart: 'in your cart',
  },
  columns: {
    product: 'Product',
    price: 'Price',
    quantity: 'Qty',
    total: 'Total',
  },
  actions: {
    remove: 'Remove',
    continueShopping: 'Continue Shopping',
    clearCart: 'Clear Shopping Cart',
  },
  summary: {
    title: 'Order Summary',
    subtotalLabel: 'Subtotal',
    shippingLabel: 'Shipping',
    taxLabel: 'Tax',
    discountLabel: 'Discount',
    totalLabel: 'Total',
    freeShippingText: 'FREE',
    freeShippingQualifier: (amount: number) => `Free shipping on orders over ₹${amount}!`,
    checkoutButton: 'Proceed to Checkout',
    secureBadge: 'Secure',
    freeReturnsBadge: 'Free Returns',
  },
} as const;

export const CHECKOUT_CONTENT = {
  empty: {
    title: 'Your cart is empty',
    description: 'Add some cuddly friends to your cart before checking out!',
    buttonLabel: 'Continue Shopping',
    buttonPath: '/shop',
  },
  title: 'Checkout',
  subtitle: 'Complete Your Order',
  description: 'Just a few steps away from hugging your new friend!',
  steps: [
    { id: 'shipping', label: 'Shipping', icon: 'Package', active: true },
    { id: 'payment', label: 'Payment', icon: 'CreditCard', active: false },
    { id: 'confirm', label: 'Confirm', icon: 'Gift', active: false },
  ] as Array<{ id: string; label: string; icon: string; active: boolean }>,
  shipping: {
    title: 'Shipping Information',
    icon: 'Package',
    fields: {
      firstName: {
        label: 'First Name *',
        placeholder: 'John',
        error: 'First name is required',
      },
      lastName: {
        label: 'Last Name *',
        placeholder: 'Doe',
        error: 'Last name is required',
      },
      email: {
        label: 'Email *',
        placeholder: 'john@example.com',
        error: 'Please enter a valid email address',
      },
      phone: {
        label: 'Phone *',
        placeholder: '+1 (555) 123-4567',
        error: 'Please enter a valid phone number',
      },
      address: {
        label: 'Address *',
        placeholder: '123 Cuddle Street',
        error: 'Address is required',
      },
      apartment: {
        label: 'Apartment, Suite, etc. (optional)',
        placeholder: 'Apt 4B',
      },
      city: {
        label: 'City *',
        placeholder: 'Softville',
        error: 'City is required',
      },
      state: {
        label: 'State *',
        placeholder: 'CA',
        error: 'State is required',
      },
      zipCode: {
        label: 'ZIP Code *',
        placeholder: '12345',
        error: 'Please enter a valid ZIP code',
      },
    },
    saveInfoLabel: 'Save this information for next time',
  },
  payment: {
    title: 'Payment Method',
    icon: 'CreditCard',
    methods: [
      {
        id: 'card',
        label: 'Credit Card',
        icon: 'CreditCard',
        description: 'Secure Credit/Debit Card',
      },
      { id: 'upi', label: 'UPI', icon: 'Smartphone', description: 'Fast UPI Payment' },
    ],
  },
  summary: {
    title: 'Order Summary',
    icon: 'FileText',
    subtotalLabel: 'Subtotal',
    shippingLabel: 'Shipping',
    taxLabel: 'Tax',
    totalLabel: 'Total',
    freeShippingText: 'FREE',
    placeOrderButton: 'Place Order Securely',
    secureText: '256-bit SSL Secure Checkout',
    processingText: 'Processing...',
    trustBadgeTitle: 'Safe & Secure Payment',
    trustBadgeDesc: 'We never store your credit card information on our servers.',
    dataProtectionText: 'Your data is protected with 256-bit SSL encryption',
  },
  errors: {
    submit: 'Failed to place order. Please try again.',
  },
} as const;

export const SUCCESS_CONTENT = {
  title: 'Order Confirmed!',
  description: "We're preparing your friends for their journey. Check your email for details.",
  orderRefLabel: 'Order Reference',
  statusTitle: 'Order Status',
  steps: [
    { label: 'Confirmed', icon: 'CheckCircle' },
    { label: 'Processing', icon: 'Package' },
    { label: 'Shipped', icon: 'Truck' },
    { label: 'Delivered', icon: 'Gift' },
  ],
  delivery: {
    title: 'Delivery Details',
    estimatedArrival: 'Estimated Arrival',
    footer: 'We will send you tracking information once your order ships.',
  },
  financial: {
    title: 'Payment Summary',
    subtotal: (items: number) => `Subtotal (${items} items)`,
    shipping: 'Shipping',
    freeShipping: 'Free',
    total: 'Total',
  },
  actions: {
    backHome: 'Back to Home',
    exploreMore: 'Explore More Toys',
  },
  support: {
    prefix: 'Need help with your order?',
    link: 'Contact our support team',
    suffix: 'we are here to help.',
  },
} as const;
